var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tree-view"),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "top", appear: "" } },
        [
          _vm.showAdd
            ? _c(
                "q-page-sticky",
                { attrs: { position: "top-right", offset: [8, 8] } },
                [
                  _c("q-btn", {
                    attrs: { round: "", color: "secondary", icon: "add" },
                    on: { click: _vm.doAdd }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1010688", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1010688","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/list.vue
// module id = null
// module chunks = 